import { render, staticRenderFns } from "./ServiceDetailTabsInvoiceError.vue?vue&type=template&id=453e5412&"
import script from "./ServiceDetailTabsInvoiceError.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsInvoiceError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports